module.exports = __webpack_public_path__ + "0ab56cba580b4287ed2ef8522730d753.jpg";